import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Network, NetworkStatus } from '@capacitor/network';
import { Platform } from '@ionic/angular';
import { MapService } from 'src/app/services/map.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-no-internet-popup',
  templateUrl: './no-internet-popup.component.html',
  styleUrls: ['./no-internet-popup.component.scss'],
})
export class NoInternetPopupComponent implements OnInit, OnDestroy {
  show = false;
  private lastConnectionStatus: boolean | null = null;
  private networkListener: any = null;

  constructor(
    private platform: Platform,
    private changeDetectorRef: ChangeDetectorRef,
    private usersService: UsersService,
    private mapService: MapService
  ) {}

  ngOnInit() {
    this.platform.ready().then(async () => {
      const networkStatus = await Network.getStatus();
      this.handleNetworkStatus(networkStatus.connected, true);
    });
    this.setupInternetListener();
  }

  ngOnDestroy() {
    if (this.networkListener) {
      // Remove our listener
      this.networkListener.remove();
      this.networkListener = null;
    }
  }

  async setupInternetListener() {
    // Store the listener reference so we can remove it specifically
    this.networkListener = await Network.addListener(
      'networkStatusChange',
      (status) => {
        console.log('Network status changed', status);
        this.handleNetworkStatus(status.connected, false);

        if (status.connected && status.connectionType === 'wifi') {
          setTimeout(() => {
            console.log('we got a wifi connection, woohoo!');
          }, 3000);
        }
      }
    );
  }

  private handleNetworkStatus(isConnected: boolean, isInitial: boolean) {
    const isComingBackOnline =
      isConnected && this.lastConnectionStatus === false;

    if (
      this.lastConnectionStatus === isConnected &&
      !isInitial &&
      !isComingBackOnline
    ) {
      return;
    }

    this.lastConnectionStatus = isConnected;

    if (isConnected) {
      this.usersService.ping().subscribe(
        () => {
          this.show = false;
          this.mapService.setOnline();
          this.mapService.getOrders(isInitial || isComingBackOnline);
          this.changeDetectorRef.detectChanges();
        },
        () => {
          this.show = true;
          this.mapService.setOffline();
          this.mapService.getOrders(false);
          this.changeDetectorRef.detectChanges();
        }
      );
    } else {
      this.show = true;
      this.mapService.setOffline();
      this.mapService.getOrders(false);
      this.changeDetectorRef.detectChanges();
    }
  }
}
